import script from "./newCam.vue?vue&type=script&lang=ts&setup=true"
export * from "./newCam.vue?vue&type=script&lang=ts&setup=true"

import "./newCam.vue?vue&type=style&index=0&id=98dcbe2a&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98dcbe2a"]])

export default __exports__